import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-lg font-bold text-foreground-950">{siteInfo.logo}</Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{siteInfo.description}</p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">分类浏览</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">品牌介绍</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">联系方式</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">用户口碑</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2">
              <p className="text-sm text-foreground-600">{siteInfo.email}</p>
              <p className="text-sm text-foreground-600">{siteInfo.phone}</p>
              <p className="text-sm text-foreground-600">{siteInfo.address}</p>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {siteInfo.foundingYear} - {new Date().getFullYear()} {siteInfo.name}. 保留所有权利。
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供学术研究与文化讨论之用
          </p>
        </div>
      </div>
    </footer>
  );
}